import { Pipe, PipeTransform } from '@angular/core';
import { SPORT_ICONS } from './sport-to-icon-name.map';

@Pipe({
    name: 'sportIconPipe'
})
export class TransformSportToIconNamePipe
    implements PipeTransform {
    transform(sport: string): string {
        for (const prop in SPORT_ICONS) {
            if (SPORT_ICONS.hasOwnProperty(prop) && prop === sport) {
                return SPORT_ICONS[prop];
            }
        }

        return sport;
    }
}
